import { useLanguageData } from '@/common/hooks/useLanguageData';
import InfoIcon from './assets/Information-szare.svg';
import LightbulbGrayIcon from './assets/lightbulb-szare.svg';
import LightbulbIcon from './assets/lightbulb.svg';
import SpeakerIcon from './assets/speakre-szare.svg';
import PauseIcon from './assets/volume-up-fill.svg';
import {
	Wrapper,
	ToggleButton,
	LightbulbIconImage,
	Bubble,
	Title,
	Text,
	Spacer,
	BottomBar,
	BottomIcon,
} from './ActiveHint.styled';
import LoadingCircle from '@/common/components/loading/LoadingCircle';
import { CSSTransition } from 'react-transition-group';
import React, { useRef, useState } from 'react';
import './animations/zoom.css';

const ActiveHint = ({
	hintData,
	expanded,
	onToggle,
	onPlayVoice,
	isVoiceLoading,
	onShowProblem,
	isVoicePlaying,
}) => {
	const langData = useLanguageData('dailyV2.hint');
	const [active, setActive] = useState(expanded);

	const bubbleRef = useRef(null);

	return (
		<Wrapper>
			<ToggleButton onClick={onToggle}>
				{langData.writeOrRecordResponse}
				<LightbulbIconImage
					src={expanded ? LightbulbIcon : LightbulbGrayIcon}
					alt='Speaker Icon'
				/>
			</ToggleButton>
			<CSSTransition
				in={expanded}
				timeout={300}
				nodeRef={bubbleRef}
				classNames='zoom'
				appear
				unmountOnExit
			>
				<Bubble ref={bubbleRef}>
					<Title>{langData.tryToSay.toUpperCase()}:</Title>
					<Text>{hintData.hint_result}</Text>
					<Spacer />
					<Text>
						<i>{hintData.hint_translation}</i>
					</Text>
					<BottomBar>
						{isVoiceLoading ? (
							<LoadingCircle />
						) : (
							<BottomIcon
								src={isVoicePlaying ? PauseIcon : SpeakerIcon}
								alt='Speaker Icon'
								onClick={() => onPlayVoice('hint', hintData.hint_result)}
							/>
						)}
						<BottomIcon
							src={InfoIcon}
							alt='Info Icon'
							onClick={() => onShowProblem(`HINT: ${hintData.hint_result}`)}
						/>
					</BottomBar>
				</Bubble>
			</CSSTransition>
		</Wrapper>
	);
};

export default ActiveHint;
